import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingCreateAccount: false
}

// getters
const getters = {
  getloadingCreateAccount () {
    return state.loadingCreateAccount
  }
}

// actions
const actions = {
  async createNewAccountMethod ({ commit, rootState }, data) {
    commit('LOADING_CREATEACCOUNT_FINISHED', false)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    // const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    let body = {}
    if (typeof data !== 'undefined') {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: data.avanzar ? data.avanzar : false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: data.claveFin ? data.claveFin : '',
            claveInicio: data.claveInicio ? data.claveInicio : '',
            entidad: config.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: data.retroceder ? data.retroceder : false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            apellid1: data.firstName ? data.firstName : '',
            apellid2: data.lastName ? data.lastName : '',
            codcuent: '',
            codentid: config.entidad,
            codpostal: data.postalCode ? data.postalCode : '',
            codprogr: data.program ? data.program : '',
            codregion: data.region ? data.region : '',
            descccue: '',
            desccpro: '',
            desclave1: data.email ? data.email : '',
            desclave2: data.phone ? data.phone : '',
            desctidc: '',
            fechacti: {
              anno: '',
              dia: '',
              format: '',
              mes: '',
              nombreDia: '',
              nombreMes: '',
              valueDate: ''
            },
            fechalta: {
              anno: '',
              dia: '',
              format: '',
              mes: '',
              nombreDia: '',
              nombreMes: '',
              valueDate: ''
            },
            fechbaja: {
              anno: '',
              dia: '',
              format: '',
              mes: '',
              nombreDia: '',
              nombreMes: '',
              valueDate: ''
            },
            fecnac: data.fecnac ? data.fecnac : '',
            idclient: data.idNumber ? data.idNumber : '',
            indblqac: '',
            indblqrd: '',
            indestciv: data.estadoCivil ? data.estadoCivil : '',
            indexiste: data.indexiste ? data.indexiste : '',
            nombre: data.name ? data.name : '',
            poblacion: data.city ? data.city : '',
            sexo: data.gender ? data.gender : '',
            tipidcli: data.typeId ? data.typeId : '',
            tipmedio1: '',
            tipmedio2: ''
          }
        }
      })
    }
    try {
      const response = await HTTP.post(config.endpoints.createAccount, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_CREATEACCOUNT_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  }
}

// mutations
const mutations = {
  'LOADING_CREATEACCOUNT_FINISHED' (state, actions) {
    state.loadingCreateAccount = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
